import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";

function SvgProcessing() {
  return _jsxs("svg", Object.assign({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, {
    children: [_jsx("path", {
      d: "M20 12a1 1 0 102 0h-2zM4 12a1 1 0 10-2 0h2zm-.888-4.586a1 1 0 101.776.918l-1.776-.918zm17.663 9.385a1 1 0 00-1.754-.961l1.754.961zM12 20a8 8 0 01-8-8H2c0 5.523 4.477 10 10 10v-2zm0-16a8 8 0 018 8h2c0-5.523-4.477-10-10-10v2zM4.888 8.332A8 8 0 0112 4V2a10 10 0 00-8.888 5.414l1.776.918zm14.133 7.506A7.998 7.998 0 0112 20v2a9.998 9.998 0 008.775-5.201l-1.754-.961z",
      fill: "currentColor"
    }, void 0), _jsx("path", {
      d: "M3.5 4v4h4M20.5 20v-4h-4",
      stroke: "currentColor",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, void 0)]
  }), void 0);
}

export default SvgProcessing;